/*  __
___( o)>
\ <_. )
 `---'
*/

import { reducer as form } from 'redux-form'
import { reducer as results } from './containers/Results/ducks'
import { reducer as dataselector } from './containers/DataSelector/ducks'

export default {
  form,
  results,
  dataselector
}
